import { useCallback } from 'react';

import { type CustomField, type CustomFieldTypeName } from '@air/api/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackRestoreCustomField.meta';

export type UseTrackRestoreCustomFieldParams = {
  custom_field_id: CustomField['id'];
  custom_field_name: CustomField['name'];
  custom_field_type: CustomFieldTypeName;
};

export const useTrackRestoreCustomField = () => {
  const { track } = useAnalyticsUtilities();

  const trackRestoreCustomField = useCallback(
    (params: UseTrackRestoreCustomFieldParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackRestoreCustomField };
};
